<template>
  <div class="slider">
    <div class="main-container">
      <div class="slider-section-desktop">
        <div class="slider-section">
          <about-us-arrow2 :title="fields.sections.value.section_one"/>
          <div class="slider-boxes">
            <div
              v-for="(box, index) in fields.shareholders.value.boxes"
              class="slide-box lead-1"
              :class="{last: fields.shareholders.value.boxes.length - 1 === index}"
            >
              <span v-html="box.text"></span>
              <div class="branch-down"></div>
            </div>
            <div
              class="slide-section-divider"
              :style="{'--num-boxes': fields.shareholders.value.boxes.length}"
            />
          </div>
        </div>
        <div class="slider-section">
          <about-us-arrow2 :title="fields.sections.value.section_two" is-primary/>
          <div class="slider-boxes">
            <div class="slider-boxes">
              <div class="slide-box lead-1">
                <seu-logo-expanded />
                <div class="branch-down"></div>
                <div class="branch-up"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(section, index) in partnersDesktop" class="slider-section">
          <about-us-arrow2 :is-hidden="index > 0" :title="fields.sections.value.section_three"/>
          <div class="slider-boxes">
            <div
              v-for="(box, index) in section"
              class="slide-box lead-1"
              :class="{last: section.length - 1 === index}"
            >
              <img :src="box.image" v-if="box.image" />
              <span  v-else v-html="box.text"></span>
              <div class="branch-up"></div>
            </div>

            <div class="slide-section-divider four dir-above"></div>
            <div v-if="index < partnersDesktop.length - 1" class="slide-section-vertical-divider"></div>
          </div>
        </div>
      </div>


      <div class="slider-section-mobile">
        <div class="slider-section">
          <div class="section-title lead-1-large">
            Aktionariat
          </div>
          <div class="slider-boxes">
            <div class="slide-box lead-1" style="padding: 48px 32px;">
             <template v-for="(box, index) in fields.shareholders.value.boxes">
               <div v-html="box.text">
               </div>
               <div v-if="index < fields.shareholders.value.boxes.length - 1" class="slide-box-divider"></div>
             </template>
              <div class="branch-down"></div>
            </div>
          </div>
        </div>

        <div class="slider-section">
          <div class="section-title primary lead-1-large">
            SEU-Holding
            <div class="branch-up"></div>
          </div>
          <div class="slider-boxes">
            <div class="slide-box lead-1" style="padding: 64px 40px;">
              <seu-logo-expanded />

              <div class="branch-down"></div>
            </div>
          </div>
        </div>

        <div class="slider-section">
          <div class="section-title lead-1-large">
            Partnerunternehmen
            <div class="branch-up"></div>
            <div class="branch-down"></div>
          </div>
        </div>

        <div v-for="(section, index) in partnersMobile" class="slider-section">
          <div class="slider-boxes">
            <div
              v-for="(box, index) in section"
              class="slide-box lead-1"
              :class="{last: section.length - 1 === index}"
              :style="{aspectRatio: '1/1'}"
            >
              <img :src="box.image" v-if="box.image" />
              <span class="box-content" v-else v-html="box.text"></span>
              <div class="branch-up"></div>
            </div>

            <div
              v-in-viewport="{transition: 'section-divider', duration: 1}"
              class="slide-section-divider dir-above"
              :style="{'--num-boxes': 2}"
            ></div>
            <div v-if="index < partnersMobile.length - 1" class="slide-section-vertical-divider"></div>
          </div>
        </div>
      </div>


<!--      <div class="slider-row">-->
<!--        <SliderBox-->
<!--          v-for="box in fields.field_one.value.boxes"-->
<!--          :slider-title="box.title"-->
<!--          :slider-description="box.description"-->
<!--        />-->
<!--      </div>-->
<!--      <slider-core-->
<!--        :main-title="fields.field_one.value.mainTitle"-->
<!--        :main-description="fields.field_one.value.mainDescription"-->
<!--      />-->

<!--      <div class="slider-row">-->
<!--        <SliderBox-->
<!--          v-for="box in fields.field_two.value.boxes"-->
<!--          :slider-title="box.title"-->
<!--          :slider-description="box.description"-->
<!--          :slider-image="box.image"-->
<!--        />-->
<!--      </div>-->
    </div>

  </div>
</template>

<script>

import SliderBox from "/seu-frontend/components/section-fields/SliderBox";
import SliderCore from "/seu-frontend/components/section-fields/SliderCore";
import AboutUsArrow from "/seu-frontend/components/icons/AboutUsArrow";
import AboutUsArrow2 from "/seu-frontend/components/icons/AboutUsArrow2";
import InViewport from "/seu-frontend/directives/inViewport";
import SeuLogoExpanded from "/seu-frontend/components/icons/SeuLogoExpanded";

function* chunks(arr, n) {
  for (let i = 0; i < arr.length; i += n) {
    yield arr.slice(i, i + n);
  }
}

export default {
  name: 'Slider',
  components: {SeuLogoExpanded, AboutUsArrow2, AboutUsArrow, SliderCore, SliderBox},
  directives: {InViewport},
  props: {
    fields: {
      type: Object,
      required: true
    },
  },

  computed: {
    partnersDesktop() {
      return [...chunks(this.fields.partners.value.boxes, 4)]
    },
    partnersMobile() {
      return [...chunks(this.fields.partners.value.boxes, 2)]
    }
  }
}
</script>

<style lang="scss">
@import "Slider";
</style>
